// extracted by mini-css-extract-plugin
export default {"scrollUpButton":"ScrollUpButton_scrollUpButton__5OVme"};